
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner-signup",
      function () {
        return require("private-next-pages/partner-signup/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner-signup"])
      });
    }
  